import React from "react";
import { Activity, AlertTriangle, Beaker, TrendingDown } from "lucide-react";

// LabMind AI — fake live dashboard mockup
export const LabMindMockup = () => {
  const reagents = [
    { name: "HbA1c Sebia", days: 12, level: 78, status: "ok" },
    { name: "TSH Beckman", days: 7, level: 32, status: "warn" },
    { name: "CRP Ultra", days: 4, level: 18, status: "alert" },
    { name: "Glucose HK", days: 21, level: 92, status: "ok" },
  ];

  return (
    <div
      className="relative w-full h-full rounded-2xl border border-sand-soft overflow-hidden bg-[#0E0E10]"
    >
      <div
        aria-hidden
        className="absolute -top-24 -right-24 w-72 h-72 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(212,111,77,0.18), rgba(212,111,77,0) 70%)",
        }}
      />

      <div className="relative p-6 md:p-7 h-full flex flex-col">
        {/* Top bar */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Beaker size={14} className="text-terracotta" />
            <span className="font-display text-sm text-maif">LabMind AI</span>
            <span className="eyebrow text-[9px] text-maif-muted">· Live</span>
          </div>
          <span className="inline-flex items-center gap-1.5 text-[10px] text-emerald-300">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
            HL7 connected
          </span>
        </div>

        {/* Hero metric */}
        <div className="mt-6 flex items-end justify-between">
          <div>
            <div className="eyebrow text-[9px]">Stockout prediction</div>
            <div className="mt-1 font-accent italic text-5xl md:text-6xl text-terracotta tracking-tighter leading-none">
              J−7
            </div>
            <div className="text-[11px] text-maif-muted mt-1">
              before next stockout
            </div>
          </div>
          <div className="text-right">
            <div className="eyebrow text-[9px]">Compliance</div>
            <div className="mt-1 font-display text-sm text-maif">ISO 15189</div>
            <div className="text-[11px] text-emerald-300 mt-0.5">
              Audit trail OK
            </div>
          </div>
        </div>

        {/* Reagent rows */}
        <div className="mt-6 space-y-2.5 flex-1">
          {reagents.map((r) => {
            const color =
              r.status === "alert"
                ? "#D46F4D"
                : r.status === "warn"
                  ? "#D9B99B"
                  : "#7CC79F";
            return (
              <div
                key={r.name}
                className="flex items-center gap-3 rounded-lg bg-white/[0.04] px-3 py-2"
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-maif truncate">{r.name}</span>
                    <span className="text-maif-muted">{r.days}d left</span>
                  </div>
                  <div className="mt-2 h-1 w-full rounded-full bg-white/[0.04] overflow-hidden">
                    <div
                      className="h-full rounded-full transition-all"
                      style={{ width: `${r.level}%`, background: color }}
                    />
                  </div>
                </div>
                {r.status === "alert" && (
                  <AlertTriangle size={12} className="text-terracotta flex-shrink-0" />
                )}
              </div>
            );
          })}
        </div>

        {/* Footer chips */}
        <div className="mt-6 flex items-center gap-2 flex-wrap">
          <span className="inline-flex items-center gap-1 rounded-full border border-sand-soft bg-white/[0.02] px-2 py-0.5 text-[10px] text-maif-muted">
            <Activity size={10} /> Real-time
          </span>
          <span className="inline-flex items-center gap-1 rounded-full border border-sand-soft bg-white/[0.02] px-2 py-0.5 text-[10px] text-maif-muted">
            FEFO · Auto-order
          </span>
          <span className="inline-flex items-center gap-1 rounded-full border border-terracotta/40 bg-terracotta/5 px-2 py-0.5 text-[10px] text-terracotta">
            <TrendingDown size={10} /> 3 stockouts prevented
          </span>
        </div>
      </div>
    </div>
  );
};

export default LabMindMockup;
